module.exports = __webpack_public_path__ + "img/VillaLoreto_Resor2t.aad43795.jpg";